import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {AccountingActions, AccountingMutation} from "@/modules/accounting/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {},
        documentType: "invoice"
    };
    listCache = [];
    listTotal = 0;
    yearlySums = {};
    formData = { states: {}, units: {}, pdfLayouts: {}, defaults: {} };

    get getAccountingRenderKey() {
        return 'accounting-' + this.renderKey;
    }

    get getAccountingLastListResult() {
        return this.listCache;
    }

    get getAccountingLastListTotal() {
        return this.listTotal;
    }

    get getAccountingYearlySums() {
        return this.yearlySums;
    }

    get getAccountingFormData() {
        return this.formData;
    }

    @Mutation
    [AccountingMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [AccountingMutation.SET_LIST_RESULT]({listParams, listTotal, listCache, yearlySums}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
        this.yearlySums = yearlySums || {};
    }

    @Mutation
    [AccountingMutation.SET_FORM_DATA](formData) {
        this.formData = formData;
    }

    // ===================== Dokumente ===================== //

    @Action
    [AccountingActions.REFRESH_LIST]() {
        this.context.dispatch(AccountingActions.FETCH_LIST, this.listParams);
    }

    @Action
    [AccountingActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("accounting/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AccountingMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result,
                    yearlySums: data.yearlySums
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`accounting/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('accounting/create/', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AccountingMutation.SET_RENDER_UPDATE);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`accounting/edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.DELETE_ITEM](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`accounting/delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AccountingActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.SET_STATE](payload) {

        return new Promise((resolve, reject) => {

            const {editId, state} = payload;

            apiService.put(`accounting/set-state/${editId}`, {state} as any).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AccountingActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.SET_PAID](payload) {

        return new Promise((resolve, reject) => {

            const {editId, paid} = payload;

            apiService.put(`accounting/set-paid/${editId}`, {paid} as any).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AccountingActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.CONVERT](payload) {

        return new Promise((resolve, reject) => {

            const {sourceId, targetType} = payload;

            apiService.get(`accounting/convert/${sourceId}/${targetType}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.FETCH_FORM_DATA]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("accounting/form-data").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AccountingMutation.SET_FORM_DATA, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.PRINT_DOCUMENT](documentId) {

        return new Promise((resolve, reject) => {

            apiService.get(`accounting/print-document/${documentId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.SEARCH_RECIPIENTS](search) {

        return new Promise((resolve, reject) => {

            apiService.post("accounting/search-recipients", {search} as any).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ===================== Produkte ===================== //

    @Action
    [AccountingActions.FETCH_PRODUCTS](params) {

        return new Promise((resolve, reject) => {

            apiService.post("accounting/products-list", params).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve({result: data.result, total: data.results});

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.GET_PRODUCT](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`accounting/products-get/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.CREATE_PRODUCT](data) {

        return new Promise((resolve, reject) => {

            apiService.post("accounting/products-create", data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.UPDATE_PRODUCT](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`accounting/products-edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.DELETE_PRODUCT](productId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`accounting/products-delete/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ===================== Settings + Nummernkreise ===================== //

    @Action
    [AccountingActions.FETCH_SETTINGS]() {

        return new Promise((resolve, reject) => {

            apiService.get("accounting/get-settings").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AccountingActions.UPDATE_SETTINGS](data) {

        return new Promise((resolve, reject) => {

            apiService.post("accounting/update-settings", data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
